module.exports = __webpack_public_path__ + "5ff1989c7ac520bf984b4919e1e2ae32.pdf";